/**
 * PULL STATION SVG placeholder art — dark holographic gold-foil card.
 * Fully copyright-safe: only geometric shapes, set codes, and brand marks.
 */
export const CardArt = ({ product, size = "md" }) => {
  const label = product?.set_code || product?.product_code || "PS";
  const category = (product?.category || "TCG").toUpperCase();
  const game = (product?.game || "TCG").replace("-", " ").toUpperCase();
  const lang = (product?.language || "").toUpperCase();

  const heights = { sm: "h-40", md: "h-56", lg: "h-80" };
  const h = heights[size] || heights.md;

  // Distinct hues per game for variety
  const isOP = product?.game === "one-piece";
  const isPKM = product?.game === "pokemon";
  const accent1 = "#C9A227";
  const accent2 = isOP ? "#8B0000" : isPKM ? "#1E3A8A" : "#0F172A";

  return (
    <div className={`relative w-full ${h} overflow-hidden bg-[#0b0b0d] border border-[#C9A227]/25`}>
      <svg viewBox="0 0 300 400" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full">
        <defs>
          <linearGradient id={`bg-${label}`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#0b0b0d" />
            <stop offset="50%" stopColor={accent2} stopOpacity="0.35" />
            <stop offset="100%" stopColor="#050505" />
          </linearGradient>
          <linearGradient id={`gold-${label}`} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#7a5d0f" />
            <stop offset="50%" stopColor="#F3D068" />
            <stop offset="100%" stopColor="#7a5d0f" />
          </linearGradient>
          <pattern id={`grid-${label}`} width="18" height="18" patternUnits="userSpaceOnUse">
            <path d="M 18 0 L 0 0 0 18" fill="none" stroke="#C9A227" strokeOpacity="0.09" strokeWidth="0.5" />
          </pattern>
        </defs>
        <rect width="300" height="400" fill={`url(#bg-${label})`} />
        <rect width="300" height="400" fill={`url(#grid-${label})`} />

        {/* Corner ornaments */}
        <path d="M 10 10 L 60 10 L 60 12 L 12 12 L 12 60 L 10 60 Z" fill={`url(#gold-${label})`} />
        <path d="M 290 10 L 240 10 L 240 12 L 288 12 L 288 60 L 290 60 Z" fill={`url(#gold-${label})`} />
        <path d="M 10 390 L 60 390 L 60 388 L 12 388 L 12 340 L 10 340 Z" fill={`url(#gold-${label})`} />
        <path d="M 290 390 L 240 390 L 240 388 L 288 388 L 288 340 L 290 340 Z" fill={`url(#gold-${label})`} />

        {/* Center emblem */}
        <g transform="translate(150 190)">
          <polygon
            points="0,-90 78,-45 78,45 0,90 -78,45 -78,-45"
            fill="none"
            stroke={accent1}
            strokeWidth="1.2"
            strokeOpacity="0.8"
          />
          <polygon
            points="0,-60 52,-30 52,30 0,60 -52,30 -52,-30"
            fill="none"
            stroke={accent1}
            strokeWidth="0.8"
            strokeOpacity="0.5"
          />
          <text textAnchor="middle" y="6" fill={`url(#gold-${label})`}
            fontFamily="Outfit, sans-serif" fontWeight="900" fontSize="34" letterSpacing="4">
            PS
          </text>
        </g>

        {/* Set code strip */}
        <rect x="20" y="330" width="260" height="26" fill="#000" fillOpacity="0.55" />
        <text x="30" y="348" fill="#F3D068" fontFamily="JetBrains Mono, monospace" fontSize="12" letterSpacing="3">
          {label}
        </text>
        <text x="270" y="348" textAnchor="end" fill="#D1D5DB" fontFamily="JetBrains Mono, monospace" fontSize="11" letterSpacing="2">
          {lang || "TCG"}
        </text>

        {/* Top label */}
        <text x="20" y="34" fill="#C9A227" fontFamily="JetBrains Mono, monospace" fontSize="9" letterSpacing="3">
          {game}
        </text>
        <text x="280" y="34" textAnchor="end" fill="#9CA3AF" fontFamily="JetBrains Mono, monospace" fontSize="9" letterSpacing="3">
          {category}
        </text>
      </svg>

      {/* Subtle sheen */}
      <div className="pointer-events-none absolute inset-0" style={{
        background: "linear-gradient(120deg, transparent 45%, rgba(255,255,255,0.06) 50%, transparent 55%)"
      }} />
    </div>
  );
};
